import { render, staticRenderFns } from "./Dxf.vue?vue&type=template&id=6b5ce42f&"
import script from "./Dxf.vue?vue&type=script&lang=js&"
export * from "./Dxf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports